<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="食物名称" prop="name" style="width: 80%">
                <el-input
                  v-model="searchForm.name"
                  placeholder="请输入食物名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="食物分类"
                prop="categoryId"
                style="width: 80%"
              >
                <el-select clearable filterable v-model="searchForm.categoryId" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="时间范围" prop="time">
                <el-date-picker
                  v-model="searchForm.time"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
        <el-button
          size="small"
          @click="onLoad(1)"
          type="primary"
          icon="el-icon-search"
          style="width: 90px"
          >搜索</el-button
        >
        <el-button
          size="small"
          @click="restSearch"
          type="danger"
          style="width: 90px"
          >重置</el-button
        >
      </div>
      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="img" label="商品图片" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.img" min-width="70" height="70" />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="商品名称" align="center">
        </el-table-column>
        <el-table-column
          prop="canteenFoodCategoryId"
          label="商品类型"
          align="center"
          :formatter="goodsType"
        >
        </el-table-column>
        <el-table-column prop="price" label="商品价格" align="center">
        </el-table-column>
        <el-table-column prop="sales" label="商品销量" align="center">
        </el-table-column>
        <el-table-column prop="foodTime" label="商品时间" align="center">
        </el-table-column>
        <el-table-column prop="status" label="是否启用" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              @change="updataStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row,'copy')"
              >复制菜单</el-button
            >            
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row,'updata')"
              >修改</el-button
            >

            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="40%">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="商品图片" prop="img">
                <upload
                  :url.sync="addData.img"
                  :src="addData.img"
                  type="img"
                  :width="215"
                  :height="215"
                ></upload>
                <div style="color: red">*(建议尺寸215px * 215px)）</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="商品名称" prop="name">
                <el-input
                  placeholder="请输入商品名称"
                  v-model="addData.name"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商品类型" prop="canteenFoodCategoryId">
                <el-select
                  clearable filterable
                  v-model="addData.canteenFoodCategoryId"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="上架日期" prop="foodTime">
                <el-date-picker
                  v-model="addData.foodTime"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商品价格" prop="price">
                <el-input-number
                  v-model="addData.price"
                  :min="0"
                  :max="9999"
                  label="请输入商品价格"
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="商品描述" prop="des">
                <el-input
                  type="textarea"
                  :rows="5"
                  placeholder="请输入内容"
                  v-model="addData.des"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import upload from "../../components/upload";
import ueditor from "../../components/ueditor";
import reg from "../../utils/reg";
export default {
  components: {
    upload,
    ueditor,
  },
  data() {
    return {
      searchForm: {
        name: "",
        categoryId: "",
        time: "",
      },
      modalTitle: "新增",
      options: [],
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      addData: {
        id: "",
        img: "",
        name: "",
        canteenFoodCategoryId: "",
        price: "",
        sales: "",
        foodTime: "",
        status: "",
        des: "",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      addDataRules: {
        img: [{ required: true, message: "请上传商品图片", trigger: "blur" }],
        name: [{ required: true, message: "请输入商品名称", trigger: "blur" }],
        canteenFoodCategoryId: [
          { required: true, message: "请选择商品分类", trigger: "blur" },
        ],
        price: [{ required: true, message: "请输入商品价格", trigger: "blur" }],
        foodTime: [
          { required: true, message: "请输入商品上架时间", trigger: "blur" },
        ],
      },
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
    };
  },
  created() {},
  mounted() {
    this.onLoad();
  },
  methods: {
    goodsType(row){
      let name = ""
      this.options.forEach(res=>{
        if(row.canteenFoodCategoryId == res.id){
          name = res.name
        }
      })
      return name
    },
    // 修改状态
    updataStatus(row) {
      let data = {
        canteenFoodId: row.id,
        status: row.status ? 1 : -1,
      };
      this.$Apis.foodUpdateStatus(data).then((res) => {
        if (res.code == 200) {
          this.onLoad();
          this.$message.success("操作成功");
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 新增角色
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.modalTitle = "新增";
      this.isAddModal = true;
    },
    // 修改角色
    updataCharacter(row,type) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.isAddModal = true;
      if(type == 'copy'){
        this.modalTitle = '复制菜单'
      }else{
        this.modalTitle = '修改'
      }
    },
    //删除角色
    del(row) {
      let canteenFoodId = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.foodDel({ canteenFoodId }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          let foodTime = reg.filterDataTime(this.addData.foodTime);
          var data = {
            img: this.addData.img,
            name: this.addData.name,
            price: this.addData.price,
            canteenFoodCategoryId: this.addData.canteenFoodCategoryId,
            status: this.addData.status || 1,
            foodTime,
            des: this.addData.des,
          };
          if(this.modalTitle == '修改'){
            data.id = this.addData.id
          }else{
            data.id = ''
          }
          this.$Apis.foodAddUp(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad(ind) {
      if(ind == 1){
        this.currentPage = 1
      }
      this.searchForm.startTime = reg.filterDataTime(this.searchForm.time[0])
      this.searchForm.endTime = reg.filterDataTime(this.searchForm.time[1])
      this.isShowloading = true;
      let {startTime,endTime,name,categoryId} = this.searchForm
      let page = {
        size: this.pageSize,
        current: this.currentPage,
        startTime,
        endTime,
        categoryId,
        name,
      };
      this.$Apis.foodClassList({ size: 100, current: 1 }).then((res) => {
        this.options = res.data.list;
      });
      this.$Apis.foodList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item, ind) => {
            item.status = item.status == 1 ? true : false;
            item.ind = ind + 1;
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
</style>